<div class="mollak-proxy">
  <div class="card">
    <h2>Mollak Internal Proxy</h2>
    <form [formGroup]="proxyForm" (ngSubmit)="onSubmit()" novalidate>
			<ng-container *ngIf="environment$ | async as selectedEnvironment">
	      <div class="form-grid">
					<label for="environment">Environment</label>
					<select id="environment" formControlName="environment">
						<option value="Production">Production (proxy, read-only)</option>
						<option value="Test">Test / Sandbox</option>
					</select>

	        <label for="requestMethod">Method</label>
	        <select id="requestMethod" formControlName="requestMethod">
	          <option value="GET">GET</option>
	          <option value="POST" [disabled]="selectedEnvironment === 'Production'">POST</option>
	        </select>

	        <label for="endpointPath">Endpoint</label>
	        <input
	          id="endpointPath"
	          type="text"
	          formControlName="endpointPath"
	          placeholder="/sync/invoices/1033136217/servicechargeperiods" />

	        <label for="requestBody">Request Body</label>
	        <textarea
	          id="requestBody"
	          formControlName="requestBody"
	          rows="6"
	        placeholder='{ "example": true }'></textarea>
	        @if (jsonError) {
          <div class="field-error">{{ jsonError }}</div>
        }
	      </div>

				<p class="hint">
					{{ getEnvironmentHint( selectedEnvironment ) }} PUT/DELETE: blocked.
				</p>
			</ng-container>

      <div class="examples">
        <strong>Examples</strong>
        <div>/sync/invoices/1033136217/servicechargeperiods</div>
        <div>/sync/receipts</div>
      </div>

      <div class="actions">
        <button type="submit" [disabled]="disabledExecute">
          @if (!isLoading) {
            <span>Execute</span>
          }
          @if (isLoading) {
            <span>Executing...</span>
          }
        </button>
        <button type="button" class="secondary" (click)="onReset()" [disabled]="isLoading">
          Reset
        </button>
      </div>
    </form>
  </div>

  @if (executionResult) {
    <div class="card response-panel">
      <div class="status-line">
        <span class="badge" [class.error]="executionResult.isError" [class.success]="!executionResult.isError">
          {{ executionResult.status }}
        </span>
        <span class="environment">{{ executionResult.environment }}</span>
        @if (executionResult.correlationId) {
          <span class="correlation">
            Correlation ID:
            <code>{{ executionResult.correlationId }}</code>
          </span>
        }
      </div>
      <pre>{{ responsePrettyPayload }}</pre>
    </div>
  }
</div>

